import * as React from 'react';
import { FieldAttributes, Field, FieldProps } from 'formik';
import { Input, InputProps } from '@components/form/input';
import { FieldMessage, FieldMessageType } from '@components/form/field';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Formik's FieldAttributes<T> intersects T into the type; any non-any replacement causes cascading type errors
export type FormikInputProps = Omit<InputProps, keyof FieldAttributes<any>> &
  FieldAttributes<any> & {
    name: string;
    type?: string;
    label?: string;
    placeholder?: string;
    placeholderPosition?: 'below-field' | 'above-field';
  };

export const FormikInput = React.forwardRef<HTMLDivElement, FormikInputProps>(
  (props, inputRef) => {
    return (
      <>
        <Field name={props.name}>
          {({ field, meta }: FieldProps) => {
            const showError = !!meta.error && meta.touched;
            const placeholder = props.placeholder;
            const placeholderPosition = props.placeholderPosition;
            const errorId = `${props.name}-error`;

            return (
              <fieldset>
                <Input
                  {...props}
                  ref={inputRef}
                  isInvalid={showError}
                  name={props.name}
                  label={props.label}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  aria-describedby={showError ? errorId : undefined}
                />
                {showError && (
                  <FieldMessage type={FieldMessageType.ERROR} id={errorId}>
                    {meta.error}
                  </FieldMessage>
                )}
                {!showError &&
                  placeholder &&
                  placeholderPosition === 'below-field' && (
                    <FieldMessage type={FieldMessageType.HINT}>
                      {placeholder}
                    </FieldMessage>
                  )}
              </fieldset>
            );
          }}
        </Field>
      </>
    );
  }
);

FormikInput.displayName = 'FormikInput';
